import { createI18n } from 'vue-i18n'
import merge from 'lodash/merge'
import store from '../state/store'
import hu from './hu.json'
import en from './en.json'

const messages = {
    hu: merge({}, hu),
    en: merge({}, en),
};

const partials = require.context('./partials', false, /\.(hu|en)\.json$/);

partials.keys().forEach((fileName) => {
    const locale = fileName.match(/\.(hu|en)\.json$/)[1];

    merge(messages[locale], partials(fileName));
});

const i18n = createI18n({
    locale: localStorage.getItem('locale') || process.env.VUE_APP_I18N_LOCALE || 'hu',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    globalInjection: true,
    silentTranslationWarn: true,
    silentFallbackWarn: true,
    missingWarn: false,
    fallbackWarn: false,
    messages,
    missing: (locale, key) => key,
})

store.$t = i18n.global.t
store.$rt = i18n.global.rt
store.$tc = i18n.global.tc
store.$te = i18n.global.te
store.$tm = i18n.global.tm
store.$d = i18n.global.d
store.$n = i18n.global.n

export default i18n
